<template>
    <div id="errors" ref="errorList">
        <div class="alert alert-danger" v-if="errorList.length">
            <template v-if="errorList.length > 1">
                <ul>
                    <li v-for="error in errorList">{{ error }}</li>
                </ul>
            </template>
            <template v-else>
                {{ errorList[0] }}
            </template>
        </div>

        <div class="modal fade" id="fatal-error-modal" tabindex="-1" role="dialog" aria-labelledby="fatalErrorLabel">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="fatalErrorLabel">
                            {{ trans('booking-process.error.fatal_error_label') }}
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>
                            {{ trans('booking-process.error.fatal_error_description') }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import lang from '../../mixins/lang';

export default {
    mixins: [lang],
    computed: mapGetters({
        errorList: 'getErrors',
        fatalError: 'getFatalError',
    }),
    methods: {
        setError(error) {
            switch (error) {
                case 'restart_session':
                    return this.trans('greenmotion.errors.quote.user_token_missing');
                    break;
                case 'please_refresh':
                    return this.trans('greenmotion.errors.quote.please_refresh');
                    break;
                default:
                    return error;
            }
        },
    },
    watch: {
        errorList() {
            this.errorList.forEach((item, index) => {
                this.errorList[index] = this.setError(item);
            });

            if (this.$refs.errorList) {
                this.$refs.errorList.scrollIntoView({ behavior: 'smooth' });
            }
        },
        fatalError(fatal) {
            if (fatal) {
                $('#fatal-error-modal').modal('show');
            }
        },
    },
};
</script>
